/** Iso3D — isometric SVG preview of the room volume on the Size tab. */
export default function Iso3D({ length, width, depth }) {
  const scale = 1.2;
  const L = Math.max(20, Math.min(200, length * scale));
  const W = Math.max(20, Math.min(150, width * scale));
  const D = Math.max(20, Math.min(150, depth * scale));
  const x = 60, y = 200, dx = W * 0.5, dy = -W * 0.3;
  const front = `${x},${y} ${x + L},${y} ${x + L},${y - D} ${x},${y - D}`;
  const top   = `${x},${y - D} ${x + L},${y - D} ${x + L + dx},${y - D + dy} ${x + dx},${y - D + dy}`;
  const right = `${x + L},${y} ${x + L + dx},${y + dy} ${x + L + dx},${y - D + dy} ${x + L},${y - D}`;
  return (
    <svg viewBox="0 0 480 280" className="w-full h-auto">
      <polygon points={front} fill="rgba(0,229,255,0.08)" stroke="#00E5FF" strokeWidth="1.5" />
      <polygon points={top}   fill="rgba(0,229,255,0.18)" stroke="#00E5FF" strokeWidth="1.5" />
      <polygon points={right} fill="rgba(0,229,255,0.04)" stroke="#00E5FF" strokeWidth="1.5" />
      <text x={x + L / 2} y={y + 20} fill="#9CA3AF" textAnchor="middle"
            fontFamily="JetBrains Mono" fontSize="11">{length} L</text>
      <text x={x + L + dx + 10} y={y - D / 2 + dy / 2} fill="#9CA3AF"
            fontFamily="JetBrains Mono" fontSize="11">{depth} D/H</text>
      <text x={x + L / 2 + dx} y={y - D + dy - 8} fill="#9CA3AF" textAnchor="middle"
            fontFamily="JetBrains Mono" fontSize="11">{width} W</text>
    </svg>
  );
}
